import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { EnumDropdownItemVariant } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { type ExportCallHistoryModalStore } from '../store/exportCallHistoryModalStore'
import styles from './styles.module.scss'

const callHistoryExportFormats = ['csv', 'txt'] as const

type IExportCallHistoryModalContentProps = {
  store: ExportCallHistoryModalStore
}

export const ExportCallHistoryModalContent: FC<IExportCallHistoryModalContentProps> = observer(
  ({ store: { format: selectedFormat, setFormat } }) => {
    return (
      <div className={styles.content}>
        <SelectField
          labelText={'Format'}
          items={callHistoryExportFormats.map((format) => ({
            id: format,
            label: format.toUpperCase(),
            variant: EnumDropdownItemVariant.CheckedRight,
          }))}
          selectProps={{
            variant: 'stroke',
            textFieldPlaceholderProps: {
              size: 'medium',
            },
          }}
          value={selectedFormat}
          setValue={setFormat}
        />
      </div>
    )
  }
)
